import {useParams} from "react-router-dom";
import {useState} from "react";
import {ADMIN_API_BASE} from "../utils/apiConfig";
import classNames from 'classnames';

const CustomSwitch = ({checked, onChange, label, disabled}) => {
    const handleClick = () => {
        if (disabled) return;
        onChange(!checked);
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={classNames(
                'flex items-center gap-3 select-none',
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
            )}
        >
            {label && <span className="text-sm text-gray-600">{label}</span>}
            <span
                className={classNames(
                    'w-12 h-6 rounded-full p-1 transition-colors duration-200',
                    checked ? 'bg-green-500' : 'bg-gray-300'
                )}
            >
                <span
                    className={classNames(
                        'block w-4 h-4 rounded-full bg-white shadow transform transition-transform duration-200',
                        checked ? '-translate-x-6' : 'translate-x-0'
                    )}
                />
            </span>
        </button>
    );
};

export default CustomSwitch;
